import moment from "moment"; // Ensure moment is imported

// Fixed type of input parameters
export const date_diff_indays = function (date1: Date, date2: Date): number {
  const dt1 = new Date(date1);
  const dt2 = new Date(date2);
  return Math.floor(
    (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
      Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
      (1000 * 60 * 60 * 24)
  );
};

export const todayIso = function (): string {
  return new Date().toISOString().split("T")[0];
};

// Quarter timeline start hour (8 AM) — differs from iteration START_TIME (16:00) in Constants.ts
const QUARTER_START_HOUR = 8;

export function getTimelineQuarter(calendarQuarterStartDate: Date): Date {
  // Base date: Thursday, January 9, 2020 (a known Thursday, verified: new Date(2020, 0, 9).getDay() === 4)
  // This anchors the 14-day iteration cycle; all iterations start on Thursdays.
  const baseDate = new Date(2020, 0, 9, 0, 0, 0, 0);
  
  // Calculate days from base date to the calendar quarter start
  const daysSinceBase = Math.floor(
    (calendarQuarterStartDate.getTime() - baseDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  
  // Find how many days into the current 14-day cycle we are
  const daysIntoCycle = daysSinceBase % 14;
  
  // Calculate days needed to reach the next Thursday (start of next cycle) that falls in or after the quarter
  const daysToNextThursday = daysIntoCycle === 0 ? 0 : 14 - daysIntoCycle;
  
  // Create the result date
  const result = new Date(2020, 0, 9, QUARTER_START_HOUR);
  result.setDate(result.getDate() + daysSinceBase + daysToNextThursday);
  
  return result;
}

export function findNextQuarterStart(date: Date): Date {
  const _endOfCalendarQuarter = moment(date).endOf("quarter").toDate();
  const _nextQuarterStart = getTimelineQuarter(_endOfCalendarQuarter);
  return _nextQuarterStart;
}

export function findPrevQuarterStart(date: Date): Date {
  const _startOfCalendarQuarter = moment(date).startOf("quarter").toDate();
  // Subtract one day
  const _dayBeforeStartOfCalendarQuarter = new Date(
    _startOfCalendarQuarter.getTime() - 1 * 24 * 60 * 60 * 1000
  );
  // Find the beginning of the previous quarter
  const _startOfPrevCalQuarter = moment(_dayBeforeStartOfCalendarQuarter)
    .startOf("quarter")
    .toDate();

  const _startOfPrevQuarter = getTimelineQuarter(_startOfPrevCalQuarter);

  return _startOfPrevQuarter;
}
